/**
 * StatTiles: a row of StatTiles for a page's headline figures, four across from the `lg` breakpoint, two from `md` and one on a phone, all the
 * same height and flush with the page's content (no nested Carbon Grid, whose own margins would indent it).
 */
import type { ReactNode } from 'react';
import './overview.scss';

export function StatTiles({ children }: { children: ReactNode }) {
  return <div className="pos-stat-tiles">{children}</div>;
}
